import { Component, OnInit, Input } from '@angular/core';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { AppConstants } from 'src/app/app.constants';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';

@Component({
  selector: 'app-change-plan',
  templateUrl: './change-plan.component.html',
  styleUrls: ['./change-plan.component.css']
})

export class ChangePlanComponent implements OnInit {
  @Input() set selectedPlan(value: any) {
    this._selectedPlan = value;
  }
  @Input() set plans(value: any) {
    this._plans = value;
  }
  @Input() set title(value: any) {
    this._title = value;
  }
  constructor(
    private formBuilder: UntypedFormBuilder,
    public functionsService: FunctionsService,
    public activeModal: NgbActiveModal,
    public constant: AppConstants,
    private apiService: ApiService) { 

    }

  _selectedPlan: any;
  formSubmitted: boolean = false;
  _plans: any;
  _title: any;

  changePlanForm = this.formBuilder.group({
    planId: ['', Validators.required]
  });
  
  ngOnInit() { this.constant.tollFreeNumber}

  savePlan(selectedPlan){
    this._selectedPlan = selectedPlan;
    this.apiService.updateCart({"Id":this._plans.id,"PlanId":this._selectedPlan}).subscribe(
        () => {
          this.apiService.getAgentDispatch().subscribe(result => {
              localStorage.setItem('agentDispatch', result['agentDispatch']);
              localStorage.setItem('geoAssignment', result['geoAssignment']);
          });
          this.activeModal.close();
        },
        error => {
          this.functionsService.errorHandler(error["status"]);
        }
    );
  }

  get planId() { return this.controlGetter('Id'); }

  controlGetter(controlName) {
    const control =  this.changePlanForm.get(controlName);
    return control && (control.touched || this.formSubmitted) ? control : {};
  }
}
